import React, { useContext, useEffect, useState } from "react";
import "./Luxury_Cab_Modal.css";
import { Col, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { getCabCategory } from "../../utils/apis/Home/Homeapi";
import { getSinglecab } from "../../utils/apis/master/Master";
import { Context } from "../../utils/context";

const Luxury_Cab_Modal = ({ show, handleClose }) => {

  const {
    IMG_URL,
  } = useContext(Context);
  const cars = [
    {
      id: 1,
      name: "Toyota Innova Crysta",
      image: "/assets/images/home/Ride_In_Comfort/img-1.png",
    },
    {
      id: 2,
      name: "Mahindra XUV700",
      image: "/assets/images/home/Ride_In_Comfort/img-1.png",
    },
    {
      id: 3,
      name: "Mahindra Scorpio-N",
      image: "/assets/images/home/Ride_In_Comfort/img-1.png",
    },
    {
      id: 4,
      name: "Toyota Innova Crysta",
      image: "/assets/images/home/Ride_In_Comfort/img-1.png",
    },
    {
      id: 5,
      name: "Mahindra XUV700",
      image: "/assets/images/home/Ride_In_Comfort/img-1.png",
    },
    {
      id: 6,
      name: "Mahindra Scorpio-N",
      image: "/assets/images/home/Ride_In_Comfort/img-1.png",
    },
  ];



  const [dataCabCategory, setDataCabCategory] = useState();
  const getAllDataCabCategory = async (show) => {

    const res = await getSinglecab(show);

    if (res?.success) {
      setDataCabCategory(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    if (show)
      getAllDataCabCategory(show?.id);

  }, [show]);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="xl"
      dialogClassName="luxury_modal"
    >
      <Modal.Header className="border-0">
        <Modal.Title className="w-100 text-center modal_title">
          Our {show?.name || ""} Cabs
        </Modal.Title>

        <div className="close_btn_holder" onClick={handleClose}>
          <FontAwesomeIcon
            icon={faXmark}
            style={{ color: "#ffffff" }}
            className="close_btn"
          />
        </div>
      </Modal.Header>

      <Modal.Body>
        <Row>
          {dataCabCategory?.map((car) => (
            <Col lg={4} md={6} sm={6} xs={6} key={car.id} className="mb-4">
              <div className="car_card">
                <div className="car_img_wrapper">
                  <img src={IMG_URL + car.image} alt={car.name} />
                </div>
                <h6 className="car_name">{car.name}</h6>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default Luxury_Cab_Modal;
